// The Iris flower dataset, with sepal length and width mapped to the x and y axes, respectively,
// and species and petal length mapped to two separate z-axes for color and size encoding.

export const irisData = [
  {
    id: 'iris-001',
    sepalLength: 5.1,
    sepalWidth: 3.5,
    petalLength: 1.4,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 97,
  },
  {
    id: 'iris-002',
    sepalLength: 4.9,
    sepalWidth: 3.0,
    petalLength: 1.4,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 95,
  },
  {
    id: 'iris-003',
    sepalLength: 4.7,
    sepalWidth: 3.2,
    petalLength: 1.3,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 96,
  },
  {
    id: 'iris-004',
    sepalLength: 5.0,
    sepalWidth: 3.6,
    petalLength: 1.4,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 98,
  },
  {
    id: 'iris-005',
    sepalLength: 5.4,
    sepalWidth: 3.9,
    petalLength: 1.7,
    petalWidth: 0.4,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 94,
  },
  {
    id: 'iris-006',
    sepalLength: 4.6,
    sepalWidth: 3.4,
    petalLength: 1.4,
    petalWidth: 0.3,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 93,
  },
  {
    id: 'iris-007',
    sepalLength: 5.0,
    sepalWidth: 3.4,
    petalLength: 1.5,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 97,
  },
  {
    id: 'iris-008',
    sepalLength: 4.4,
    sepalWidth: 2.9,
    petalLength: 1.4,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 91,
  },
  {
    id: 'iris-009',
    sepalLength: 5.4,
    sepalWidth: 3.7,
    petalLength: 1.5,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 96,
  },
  {
    id: 'iris-010',
    sepalLength: 4.8,
    sepalWidth: 3.4,
    petalLength: 1.6,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 94,
  },
  {
    id: 'iris-011',
    sepalLength: 5.8,
    sepalWidth: 4.0,
    petalLength: 1.2,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 99,
  },
  {
    id: 'iris-012',
    sepalLength: 5.7,
    sepalWidth: 4.4,
    petalLength: 1.5,
    petalWidth: 0.4,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 98,
  },
  {
    id: 'iris-013',
    sepalLength: 5.4,
    sepalWidth: 3.4,
    petalLength: 1.7,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 95,
  },
  {
    id: 'iris-014',
    sepalLength: 5.1,
    sepalWidth: 3.7,
    petalLength: 1.5,
    petalWidth: 0.4,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 97,
  },
  {
    id: 'iris-015',
    sepalLength: 4.6,
    sepalWidth: 3.6,
    petalLength: 1.0,
    petalWidth: 0.2,
    species: 'Setosa',
    prediction: 'Setosa',
    confidence: 99,
  },
  {
    id: 'iris-016',
    sepalLength: 7.0,
    sepalWidth: 3.2,
    petalLength: 4.7,
    petalWidth: 1.4,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 88,
  },
  {
    id: 'iris-017',
    sepalLength: 6.4,
    sepalWidth: 3.2,
    petalLength: 4.5,
    petalWidth: 1.5,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 84,
  },
  {
    id: 'iris-018',
    sepalLength: 6.9,
    sepalWidth: 3.1,
    petalLength: 4.9,
    petalWidth: 1.5,
    species: 'Versicolor',
    prediction: 'Virginica',
    confidence: 61,
  },
  {
    id: 'iris-019',
    sepalLength: 5.5,
    sepalWidth: 2.3,
    petalLength: 4.0,
    petalWidth: 1.3,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 79,
  },
  {
    id: 'iris-020',
    sepalLength: 6.5,
    sepalWidth: 2.8,
    petalLength: 4.6,
    petalWidth: 1.5,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 82,
  },
  {
    id: 'iris-021',
    sepalLength: 5.7,
    sepalWidth: 2.8,
    petalLength: 4.5,
    petalWidth: 1.3,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 76,
  },
  {
    id: 'iris-022',
    sepalLength: 6.3,
    sepalWidth: 3.3,
    petalLength: 4.7,
    petalWidth: 1.6,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 80,
  },
  {
    id: 'iris-023',
    sepalLength: 4.9,
    sepalWidth: 2.4,
    petalLength: 3.3,
    petalWidth: 1.0,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 85,
  },
  {
    id: 'iris-024',
    sepalLength: 6.6,
    sepalWidth: 2.9,
    petalLength: 4.6,
    petalWidth: 1.3,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 83,
  },
  {
    id: 'iris-025',
    sepalLength: 5.2,
    sepalWidth: 2.7,
    petalLength: 3.9,
    petalWidth: 1.4,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 78,
  },
  {
    id: 'iris-026',
    sepalLength: 5.0,
    sepalWidth: 2.0,
    petalLength: 3.5,
    petalWidth: 1.0,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 81,
  },
  {
    id: 'iris-027',
    sepalLength: 5.9,
    sepalWidth: 3.0,
    petalLength: 4.2,
    petalWidth: 1.5,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 86,
  },
  {
    id: 'iris-028',
    sepalLength: 6.0,
    sepalWidth: 2.2,
    petalLength: 4.0,
    petalWidth: 1.0,
    species: 'Versicolor',
    prediction: 'Virginica',
    confidence: 58,
  },
  {
    id: 'iris-029',
    sepalLength: 6.1,
    sepalWidth: 2.9,
    petalLength: 4.7,
    petalWidth: 1.4,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 77,
  },
  {
    id: 'iris-030',
    sepalLength: 5.6,
    sepalWidth: 2.9,
    petalLength: 3.6,
    petalWidth: 1.3,
    species: 'Versicolor',
    prediction: 'Versicolor',
    confidence: 89,
  },
  {
    id: 'iris-031',
    sepalLength: 6.3,
    sepalWidth: 3.3,
    petalLength: 6.0,
    petalWidth: 2.5,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 91,
  },
  {
    id: 'iris-032',
    sepalLength: 5.8,
    sepalWidth: 2.7,
    petalLength: 5.1,
    petalWidth: 1.9,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 87,
  },
  {
    id: 'iris-033',
    sepalLength: 7.1,
    sepalWidth: 3.0,
    petalLength: 5.9,
    petalWidth: 2.1,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 92,
  },
  {
    id: 'iris-034',
    sepalLength: 6.3,
    sepalWidth: 2.9,
    petalLength: 5.6,
    petalWidth: 1.8,
    species: 'Virginica',
    prediction: 'Versicolor',
    confidence: 63,
  },
  {
    id: 'iris-035',
    sepalLength: 6.5,
    sepalWidth: 3.0,
    petalLength: 5.8,
    petalWidth: 2.2,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 89,
  },
  {
    id: 'iris-036',
    sepalLength: 7.6,
    sepalWidth: 3.0,
    petalLength: 6.6,
    petalWidth: 2.1,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 95,
  },
  {
    id: 'iris-037',
    sepalLength: 4.9,
    sepalWidth: 2.5,
    petalLength: 4.5,
    petalWidth: 1.7,
    species: 'Virginica',
    prediction: 'Versicolor',
    confidence: 55,
  },
  {
    id: 'iris-038',
    sepalLength: 7.3,
    sepalWidth: 2.9,
    petalLength: 6.3,
    petalWidth: 1.8,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 93,
  },
  {
    id: 'iris-039',
    sepalLength: 6.7,
    sepalWidth: 2.5,
    petalLength: 5.8,
    petalWidth: 1.8,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 88,
  },
  {
    id: 'iris-040',
    sepalLength: 7.2,
    sepalWidth: 3.6,
    petalLength: 6.1,
    petalWidth: 2.5,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 94,
  },
  {
    id: 'iris-041',
    sepalLength: 6.5,
    sepalWidth: 3.2,
    petalLength: 5.1,
    petalWidth: 2.0,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 86,
  },
  {
    id: 'iris-042',
    sepalLength: 6.4,
    sepalWidth: 2.7,
    petalLength: 5.3,
    petalWidth: 1.9,
    species: 'Virginica',
    prediction: 'Versicolor',
    confidence: 60,
  },
  {
    id: 'iris-043',
    sepalLength: 6.8,
    sepalWidth: 3.0,
    petalLength: 5.5,
    petalWidth: 2.1,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 90,
  },
  {
    id: 'iris-044',
    sepalLength: 5.7,
    sepalWidth: 2.5,
    petalLength: 5.0,
    petalWidth: 2.0,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 84,
  },
  {
    id: 'iris-045',
    sepalLength: 5.8,
    sepalWidth: 2.8,
    petalLength: 5.1,
    petalWidth: 2.4,
    species: 'Virginica',
    prediction: 'Virginica',
    confidence: 87,
  },
];
